import axios from "axios";
import * as types from "./Assistants.types";

const contentfulSpaceId = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
const contentfulApiKey = process.env.REACT_APP_CONTENTFUL_API_KEY;

const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${contentfulApiKey}`,
};

const query = `
  query {
    assistantCollection(
      order: sys_firstPublishedAt_ASC
    ) {
      items {
        sys {
          firstPublishedAt
        }
        name
        photo {
          url
        }
        charge
        program
      }
    }
  }
`;

export const assistantService = async (): Promise<types.QueryResponse> => {
  try {
    const { data } = await axios.post(
      `https://graphql.contentful.com/content/v1/spaces/${contentfulSpaceId}/environments/master`,
      JSON.stringify({ query }),
      { headers }
    );
    return data;
  } catch (error) {
    if (
      axios.isAxiosError(error) &&
      error.response &&
      error.response.status === 401
    )
      throw new Error(error.response.data.message);
    throw new Error(
      "En este momento el servicio no está disponible. Inténtalo nuevamente más tarde."
    );
  }
};
